export default __webpack_public_path__ + "static/media/Bottom_upload.cd4c3e43.svg";